import script from "./HeaderProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderProfile.vue?vue&type=script&setup=true&lang=js"

import "./HeaderProfile.vue?vue&type=style&index=0&id=a11d35f2&lang=scss"

const __exports__ = script;

export default __exports__